import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import 'dayjs/locale/el'

// Apply the UTC plugin
dayjs.extend(utc)

// Apply greek locale
dayjs.locale('el')

/**
 * Converts a UNIX timestamp to a formatted date string 'dd/mm/yyyy'.
 * @param {number} timestamp - The UNIX timestamp in milliseconds.
 * @param {string} format - The desired output format (defaults to "DD/MM/YYYY").
 * @return {string} - The formatted date string.
 */
function timestampToDate(timestamp, format = 'DD/MM/YYYY') {
  // Check if timestamp is a number
  if (typeof timestamp !== 'number') {
    throw new Error('Invalid timestamp: Input must be a number.')
  }

  return dayjs(timestamp).format(format)
}

/**
 * Converts a UNIX timestamp to a formatted date and time string 'dd/mm/yyyy HH:MM'.
 * @param {number} timestamp - The UNIX timestamp in milliseconds.
 * @param {string} format - The desired output format (defaults to "DD/MM/YYYY HH:mm").
 * @return {string} - The formatted date and time string.
 */
function timestampToDateTime(timestamp, format = 'DD/MM/YYYY HH:mm') {
  // Check if timestamp is a number
  if (typeof timestamp !== 'number') {
    throw new Error('Invalid timestamp: Input must be a number.')
  }

  return dayjs(timestamp).format(format)
}

/**
 * Formats a given JavaScript Date object according to the specified format.
 * @param {Date} dateObj - The JavaScript Date object.
 * @param {string} format - The desired output format (defaults to "DD/MM/YYYY").
 * @return {string} - The formatted date string.
 */
function formatDate(dateObj, format = 'DD/MM/YYYY') {
  // Check if the input is a Date object
  if (!(dateObj instanceof Date)) {
    throw new Error('Invalid input: Expected a Date object.')
  }

  // Check if the Date object is valid
  if (isNaN(dateObj.getTime())) {
    throw new Error('Invalid date: The Date object is not valid.')
  }

  // Convert the Date object to a dayjs object
  const dayjsDate = dayjs(dateObj)

  // Format the date according to the provided format string
  return dayjsDate.format(format)
}

// /**
//  * Converts a date string to a UNIX timestamp in milliseconds.
//  * @param {string} dateString - The date string in a recognizable format.
//  * @return {number} - The UNIX timestamp in milliseconds.
//  */
// function dateToTimestamp(dateString) {
//   // Validate input is a string
//   // if (typeof dateString !== 'string') {
//   //     throw new Error('Invalid input: Date must be a string.');
//   // }

//   // Parse the date string into a dayjs object
//   const parsedDate = dayjs(dateString);

//   // Check if the date parsing was successful
//   if (!parsedDate.isValid()) {
//       throw new Error('Invalid date: Parsing failed.');
//   }

//   // Convert the date to a UNIX timestamp in milliseconds
//   return parsedDate.valueOf();
// }

/**
 * Converts duration to string in 'hh:mm:ss' format
 * @param {string} duration - The duration in seconds
 * @returns
 */
const formatDuration = (duration) => {
  if (!duration) return '00:00:00'
  const seconds = Math.floor(duration)
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
}

export { timestampToDate, timestampToDateTime, formatDate, formatDuration }
